import {Component, Input, OnInit} from '@angular/core';
import {RouteUrls} from '../../../shared/constants/RouteUrls';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GeneralConstant} from '../../../shared/constants/GeneralConstant';
import {environment} from '../../../../environments/environment';
import {Actions, ApiEndpoints} from '../../../shared/constants/ApiEndpoints';
import {RequestMethod, RestService} from '../../../shared/services/rest.service';
import {ResponseSnackbarService} from '../../../shared/services/response-snackbar.service';
import {StripeAddCardComponent} from './stripe-add-card/stripe-add-card.component';
import {TokenService} from '../../../shared/services/token.service';
import {Partner} from '../../../shared/models/res/partner';
import {Payment} from '../../../shared/models/account/payment';
import {UploadProfilePictureComponent} from './upload-profile-picture/upload-profile-picture.component';
import {PermissionLink} from '../../../shared/permission/PermissionLink';
import {checkForPermission} from '../../../shared/permission/check-permission';
import {debounceTime, finalize, take} from 'rxjs/operators';
import {PageableResponse} from '../../../shared/models/datasource/pageable-response';
import {SurveyorSurveyType} from '../../../shared/enums/survey/SurveyorSurveyType';
import {Country} from '../../../shared/models/res/country';
import {CountriesEnum} from '../../../shared/enums/res/Countries';
import {State} from '../../../shared/models/res/state';
import {LocationService} from '../../../shared/services/location.service';
import {RequestService, RestStore} from '@ucx/ui-lib';
import {FacilityProgram} from '../../../shared/models/accr/FacilityProgram';
import {reactiveFormValidator} from '../../../shared/utils/Reactive-form-validation-trigger';
import {StaffService} from '../../../shared/services/staff.service';
import {licenseRoles, roles} from '../../../shared/enums/res/roles';
import {LicenseInfoFormComponent} from '../../shared/modules/license-info-form/license-info-form.component';
import {LicenseInfo} from '../../../shared/models/accr/LicenseInfo';
import {Assignee} from '../../../shared/models/accr/Assignee';
import {DatePipe} from '@angular/common';
import {MessageInfo} from '../../../shared/enums/error-messages/MessageInfo';
import {TooltipService} from '../../../shared/services/tooltip.service';
import * as uuid from 'uuid';
import {UserService} from '../../../shared/services/user.service';
import {ConfirmModalComponent} from '../../shared/modules/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  /**
   * is license mandatory
   */
  isLicenseMandatory = false;

  /**
   * logout path
   */
  logoutPath = '/' + RouteUrls.LOGOUT;
  /**
   * My profile
   */
  myProfile = true;
  /**
   * change password
   */
  changePassword = false;
  /**
   * account settings
   */
  accountSettings = false;

  /**
   * Date time formatted
   */
  dateformat = GeneralConstant.DATE_FORMAT;

  /**
   * licenses
   */
  licenses = false;

  /**
   * work address
   */
  workAddress = false;
  /**
   * My profile form group
   */
  myProfileFormGroup: FormGroup;

  /**
   * Change password form group
   */
  changePasswordFormGroup: FormGroup;

  /**
   * Work Address form group
   */
  workAddressFormGroup: FormGroup;

  /**
   * save changes loading.
   */
  saveBtnLoading = false;

  /**
   * Update button loading.
   */
  updateBtnLoading = false;

  readPaymentPermission = PermissionLink.appendLink(ApiEndpoints.ACCOUNT.PAYMENT, Actions.BASE_ACTIONS.CREATE);

  /**
   * Hide Current Password
   */
  hideCurrentPassword = true;
  /**
   * Hide New Password
   */
  hideNewPassword = true;
  /**
   * Hide Confirm Password
   */
  hideConfirmPassword = true;

  public cards;
  public asterisk: any;
  public defaultCard: string;
  public cardBrand: string;
  @Input() card: any;

  assignee: Assignee;
  user: Partner;
  workPartner: Partner;
  email: any;
  workCountyList: State[] = [];
  spokenLanguages = [];
  programs = [];
  assignedPrograms = [];
  specialties = [];
  workPrefix: any = {
    id: 235,
    code: 'US',
    phoneCode: '1'
  };
  homePrefix: any = {
    id: 235,
    code: 'US',
    phoneCode: '1'
  };
  workFaxPrefix: any = {
    id: 235,
    code: 'US',
    phoneCode: '1'
  };
  surveyTypes = Object.keys(SurveyorSurveyType).map(key => {
    return {key, value: SurveyorSurveyType[key]};
  });
  countryList: Country[] = [];
  usaId = CountriesEnum.USA;
  stateList: State[] = [];
  licenceData: LicenseInfo[] = [];
  usersStore: RestStore<any>;
  certifyingBoardData: any;
  memberBoardData: any;
  isGlobalAdmin: boolean;
  isSurveyor: boolean;
  isAccreditationSpecialist: boolean;
  isClinicalReviewer: boolean;
  isSchedulingTeam: boolean;
  showEffectiveDate = true;
  showExpirationDate = true;
  showCountryIssued = true;
  showStateIssued = true;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  invalidEmail = MessageInfo.LIMIT_6_AND_100;
  invalidAddress = MessageInfo.LIMIT_1_AND_255;
  invalidZip = MessageInfo.LIMIT_1_AND_10;
  invalidCity = MessageInfo.LIMIT_1_AND_100;
  invalidPassword = MessageInfo.MIN_8_CHAR;
  tooltipService: any;

  constructor(
    public dialogRef: MatDialogRef<MyProfileComponent>,
    private formBuilder: FormBuilder,
    private restService: RestService,
    public dialog: MatDialog,
    private snackBar: ResponseSnackbarService,
    private tokenService: TokenService,
    private responseSnackBar: ResponseSnackbarService,
    private locationService: LocationService,
    private requestService: RequestService,
    private staffService: StaffService,
    private datePipe: DatePipe,
    private userService: UserService,
    private matDialog: MatDialog,
    private dlg: MatDialogRef<MyProfileComponent>
  ) {
  }

  get logo() {
    return this.user && this.user.logo ? this.user.logo.filePath : 'https://www.w3schools.com/howto/img_avatar2.png';
  }

  ngOnInit() {
    this.getMyProfile();
    this.isLicenseMandatory = this.tokenService.getRolesFromToken().some(it => licenseRoles().map(x => x.name).includes(it));
    this.isGlobalAdmin = this.tokenService.getRolesFromToken().filter(it => it === roles.GLOBAL_ADMIN.name).length === 1;
    this.isSurveyor = this.tokenService.getRolesFromToken().filter(it => it === roles.SURVEYOR.name).length === 1;
    this.isAccreditationSpecialist = this.tokenService.getRolesFromToken().filter(it => it === roles.ACCREDITATION_SPECIALIST.name).length === 1;
    this.isClinicalReviewer = this.tokenService.getRolesFromToken().filter(it => it === roles.CLINICAL_REVIEWER.name).length === 1;
    this.isSchedulingTeam = this.tokenService.getRolesFromToken().filter(it => it === roles.CLINICAL_REVIEWER.name).length === 1;
    if (checkForPermission(this.readPaymentPermission)) {
      this.getAllCards();
    }
    this.getPrograms();
    this.getAllSpokenLanguages();
    if (this.user?.id) {
      this.getAssignedFacilites();
    }
    this.getSpecialties();
    this.getAllCertifyingBoardTypes();
    this.getCountries();
  }

  setWorkPrefix(event: any) {
    if (event.isUserInput) {
      this.workPrefix = this.countryList.find(item => (item.id === event.source.value));
    }
  }

  setWorkFaxPrefix(event: any) {
    if (event.isUserInput) {
      this.workFaxPrefix = this.countryList.find(item => (item.id === event.source.value));
    }
  }

  /**
   * Activate profile
   */
  public activateProfile() {
    this.myProfile = true;
    this.changePassword = false;
    this.accountSettings = false;
    this.workAddress = false;
    this.licenses = false;
  }

  /**
   * Activate change password
   */
  public activatePassword() {
    this.myProfile = false;
    this.changePassword = true;
    this.accountSettings = false;
    this.workAddress = false;
    this.licenses = false;
  }

  /**
   * Activate settings
   */
  public activateSettings() {
    this.myProfile = false;
    this.changePassword = false;
    this.accountSettings = true;
    this.workAddress = false;
    this.licenses = false;
  }

  /**
   * Activate settings
   */
  public activateWorkAddress() {
    this.myProfile = false;
    this.changePassword = false;
    this.accountSettings = false;
    this.workAddress = true;
    this.licenses = false;
  }

  /**
   * Activate licenses
   */

  activateLicenses() {
    this.myProfile = false;
    this.changePassword = false;
    this.accountSettings = false;
    this.workAddress = false;
    this.licenses = true;
  }

  changePhoto() {
    const dialogRef = this.dialog.open(UploadProfilePictureComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.user) {
        this.user.logo = result;
        this.restService.request<Payment>(
          RequestMethod.POST,
          ApiEndpoints.RES.PARTNER,
          'update-profile',
          {
            body: this.user
          }
        ).subscribe(response => {
          this.snackBar.onResponse(response);
        });
      }
    });
  }

  /**
   * Add new card.
   * Re-render list of cards.
   */
  onAddNewCard(): void {
    const dialogRef = this.dialog.open(StripeAddCardComponent, {});

    dialogRef.afterClosed().subscribe(result => {
      this.getAllCards();
    });
  }

  /*
  ** Open Delete Modal for Deleting Card
   */
  onOpenDeleteModalCard(card: any): void {
    this.removeCard(card);
  }

  /*
  ** Set Card Default
   */
  onSetCardDefault(cardId: any): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/set_default`;

    this.restService.restRequest(
      RequestMethod.PUT,
      URL,
      {
        body: {
          card: cardId
        }
      }
    ).subscribe(response => {
      this.onShowSnackBar(response);
    });
  }

  /*
  ** Remove Card
   */
  removeCard(cardId: any): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.DELETE}/card`;

    this.restService.restRequest(
      RequestMethod.DELETE,
      URL,
      {
        body: {
          card: cardId
        }
      }
    ).subscribe(response => {
      this.onShowSnackBar(response);
    });
  }

  /**
   * Add new license.
   * Re-render list of cards.
   */
  onAddNewLicense(): void {
    const dialogRef = this.dialog.open(LicenseInfoFormComponent, {});
    dialogRef.componentInstance.licenseInfo = new LicenseInfo();
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.licenceData.push(result);
        this.saveLicenses();
      }
    });
  }

  /**
   * Update license line.
   * @param row r
   * @param index i
   */
  onUpdateLicense(index: number) {
    const dialog = this.dialog.open(LicenseInfoFormComponent, {panelClass: 'w-overflow-auto'});
    dialog.componentInstance.licenseInfo = this.licenceData[index];
    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.licenceData[index] = result;
        this.saveLicenses();

      }
    });

  }

  /**
   * Remove a license from list.
   * @param index i
   */
  removeLicense(index: number) {
    this.licenceData.splice(index, 1);
    this.saveLicenses();
  }

  getMyProfile() {
    this.restService.request<any>(
      RequestMethod.GET,
      'profile',
      Actions.BASE_ACTIONS.READ + '/me'
    ).subscribe(response => {
      if (response.success) {
        this.user = response.data.contact;
        this.workPartner = response.data.workPartner;
        this.email = this.tokenService.getUserFromToken().email;
        this.initMyProfileForm();
        this.initLicenses();
      } else {
        this.initMyProfileForm();
      }
      this.initWorkAddressForm();
    });
    this.initChangePasswordForm();
  }

  /**
   * Initialize profile form
   */
  initMyProfileForm() {
    if (this.user?.assignee?.certifyingBoard?.id) {
      this.getMemberBoardTypes(this.user?.assignee?.certifyingBoard?.id);
    }
    this.myProfileFormGroup = this.formBuilder.group({
      firstName: new FormControl(this.user?.firstName,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      middleName: new FormControl(this.user.middleName,
        [Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      lastName: new FormControl(this.user.lastName,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]),
      userName: new FormControl({
        value: this.tokenService.getUserFromToken() ? this.tokenService.getUserFromToken().username : null,
        disabled: true
      }),
      email: new FormControl({
        value: this.tokenService.getUserFromToken() ? this.tokenService.getUserFromToken().email : null,
        disabled: true
      }, Validators.compose([Validators.required, Validators.pattern(GeneralConstant.EMAIL_REGEX_VALIDATOR)])),
      role: new FormControl({
        value: this.tokenService.getUserFromToken() ? this.tokenService.getRolesFromToken().map(value => ' ' + value) : null,
        disabled: true
      }),
      suffix: new FormControl(this.user?.suffix),
      credentials: new FormControl(this.user?.credentials),
      spokenLanguages: new FormControl(this.user?.assignee?.spokenLanguages?.map(it => it.id)),
      programs: new FormControl(this.user?.assignee?.facilityPrograms?.map(it => it.id)),
      specialties: new FormControl(this.user?.assignee?.specialties?.map(it => it.id)),
      surveyTypes: new FormControl(this.user?.assignee?.surveyorSurveyTypes),
      certifyingBoard: new FormControl(this.user?.assignee?.certifyingBoard?.id),
      memberBoard: new FormControl(this.user?.assignee?.memberBoard?.id, Validators.required)

    });


    if (!this.user?.assignee?.certifyingBoard?.id) {
      this.myProfileFormGroup.get('memberBoard').disable();
    }

    if (this.isGlobalAdmin) {
      this.myProfileFormGroup.controls.spokenLanguages.disable();
      this.myProfileFormGroup.controls.programs.disable();
      this.myProfileFormGroup.controls.surveyTypes.disable();
      this.myProfileFormGroup.controls.certifyingBoard.disable();
      this.myProfileFormGroup.controls.memberBoard.disable();
    }

    if (this.isAccreditationSpecialist || this.isClinicalReviewer || this.isSurveyor) {
      this.myProfileFormGroup.get('programs').disable();
    }

    this.myProfileFormGroup.controls.userName.disable();
    this.myProfileFormGroup.controls.email.disable();
    this.tooltipService = new TooltipService(this.myProfileFormGroup);
  }


  /**
   * Initialize password form
   */
  initChangePasswordForm() {
    this.changePasswordFormGroup = this.formBuilder.group({
      currentPassword: new FormControl(),
      newPassword: new FormControl(null, [
        Validators.required,
        Validators.pattern(GeneralConstant.PASSWORD_REGEX_VALIDATOR),
        Validators.minLength(8)]),
      confirmNewPassword: new FormControl({
        value: null,
        disabled: true
      }, [
        Validators.required,
        Validators.pattern(GeneralConstant.PASSWORD_REGEX_VALIDATOR),
        Validators.minLength(8)])
    }, {
      validator: ((text, match) => (formGroup: FormGroup) => {
        const control = formGroup.controls[text];
        const matchingControl = formGroup.controls[match];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          return;
        }

        if (control.value !== matchingControl.value) {
          matchingControl.setErrors({mustMatch: true});
        } else {
          matchingControl.setErrors(null);
        }
      })('newPassword', 'confirmNewPassword')
    });

    const confirmNewPassword = this.changePasswordFormGroup.get('newPassword');
    confirmNewPassword.valueChanges
      .pipe(
        debounceTime(500)
      ).subscribe(() => {
      if (this.changePasswordFormGroup.get('newPassword').invalid) {
        this.changePasswordFormGroup.controls.confirmNewPassword.disable();
        this.changePasswordFormGroup.controls.confirmNewPassword.reset();
      } else {
        this.changePasswordFormGroup.controls.confirmNewPassword.enable();
      }
    });
  }

  /**
   * Initialize work address form
   */
  initWorkAddressForm() {
    this.workAddressFormGroup = this.formBuilder.group({
      workStreet1: new FormControl(this.workPartner?.street1,
        [Validators.required, Validators.maxLength(255)]),
      workStreet2: new FormControl(this.workPartner?.street2,
        [Validators.maxLength(255)]),
      workCity: new FormControl(this.workPartner?.city,
        [Validators.required, Validators.maxLength(100), Validators.pattern(GeneralConstant.ALPHANUMERIC_AND_SYMBOL_REGEX_VALIDATOR)]),
      workState: new FormControl({
        value: this.workPartner?.state?.id,
        disabled: (this.workPartner?.country?.id ?? this.workPrefix.id) !== this.workPrefix.id
      }, Validators.required),
      workCounty: new FormControl({
        value: this.workPartner?.county?.id,
        disabled: !this.workPartner?.state?.id
      }, Validators.required),
      workCountry: new FormControl(this.workPartner?.country?.id ?? this.workPrefix.id, Validators.required),
      workZipCode: new FormControl(this.workPartner?.zipCode, [Validators.required, Validators.maxLength(10), Validators.pattern(GeneralConstant.ZIP_REGEX_VALIDATOR)]),
      workPhone: new FormControl(this.workPartner?.phone,
        [Validators.required, Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.PHONE_REGEX_VALIDATOR)]),
      workFax: new FormControl(this.workPartner?.fax, [Validators.minLength(2), Validators.maxLength(100), Validators.pattern(GeneralConstant.PHONE_REGEX_VALIDATOR)]),
      workPrefix: new FormControl(+(this.workPartner?.phoneExtension ?? this.workPrefix.id), Validators.required),
      workFaxPrefix: new FormControl(+(this.workPartner?.faxExtension ?? this.workPrefix.id)),
    });
    this.tooltipService = new TooltipService(this.workAddressFormGroup);
    this.workPrefix = this.countryList.find(item => (item.id === this.workAddressFormGroup.get('workPrefix').value));
    this.workFaxPrefix = this.countryList.find(item => (item.id === this.workAddressFormGroup.get('workFaxPrefix').value));
    this.getCounties(this.workAddressFormGroup.get('workState'), this.workAddressFormGroup.get('workCounty'), 'workCounty', this.workAddressFormGroup.get('workState').value);
  }

  initLicenses() {
    if (this.user?.assignee?.licenses) {
      this.licenceData = this.user?.assignee?.licenses;
    }
  }

  /**
   * Save profile
   */
  saveProfile() {
    if (this.myProfileFormGroup.invalid) {
      reactiveFormValidator(this.myProfileFormGroup);
      this.saveBtnLoading = false;
      return;
    }
    if (this.user?.assignee?.certifyingBoard) {
      this.getMemberBoardTypes(this.user?.assignee?.certifyingBoard?.id);
    }
    this.saveBtnLoading = true;
    const value = this.myProfileFormGroup.getRawValue();
    this.user.firstName = value.firstName;
    this.user.middleName = value.middleName;
    this.user.lastName = value.lastName;
    this.user.name = value.firstName + ' ' + value.lastName;
    this.user.credentials = value.credentials;
    this.user.suffix = value.suffix;

    this.user.assignee.surveyorSurveyTypes = value.surveyTypes;
    this.user.assignee.certifyingBoard = value.certifyingBoard ? {id: value.certifyingBoard} : null;
    this.user.assignee.memberBoard = value.memberBoard ? {id: value.memberBoard} : null;

    if (!this.isGlobalAdmin && !this.isSurveyor) {
      this.user.assignee.spokenLanguages = value.spokenLanguages?.map(it => {
        return {id: it};
      });
      this.user.assignee.facilityPrograms = value.programs?.map(it => {
        return {id: it};
      });
      this.user.assignee.specialties = value.specialties?.map(it => {
        return {id: it};
      });

    } else {
      if (this.isSurveyor) {
        this.user.assignee.specialties = value.specialties?.map(it => {
          return {id: it};
        });
      } else {
        this.user.assignee = null;
      }
    }

    if (!this.user?.assignee?.certifyingBoard?.id) {
      this.myProfileFormGroup.get('memberBoard').disable();
    }
    this.restService.request<Payment>(
      RequestMethod.POST,
      ApiEndpoints.RES.PARTNER,
      'update-profile',
      {
        body: this.user,
        params: {ignoreNullsExcept: ['assignee.certifyingBoard', 'assignee.memberBoard'], changeProfilePicture: false}
      }
    )
      .pipe(
        take(1),
        finalize(() => {
          this.saveBtnLoading = false;
        })
      )
      .subscribe(response => {
        this.snackBar.onResponse(response);
        this.dialogRef.close();
      });
  }

  /**
   * Save Licenses
   */
  saveLicenses() {
    this.restService.request<Payment>(
      RequestMethod.POST,
      ApiEndpoints.RES.PARTNER,
      'update_licenses' + '/' + this.tokenService.getUserFromToken().contact.id,
      {
        body: this.licenceData,

      }
    )
      .pipe(
        take(1),
        finalize(() => {
          this.saveBtnLoading = false;
        })
      )
      .subscribe(response => {
        this.snackBar.onResponse(response);
      });
  }

  /**
   * Save password
   */
  savePassword() {
    this.updateBtnLoading = true;
    if (this.changePasswordFormGroup.invalid) {
      this.updateBtnLoading = false;
      return;
    }
    this.userService.setUserUUID(uuid.v4());
    const value = this.changePasswordFormGroup.value;
    this.user.firstName = value.firstName;
    this.user.middleName = value.middleName;
    this.user.lastName = value.lastName;
    this.restService.request<any>(
      RequestMethod.PUT,
      ApiEndpoints.RES.UPDATE_PASSWORD,
      'update-user-password',
      {
        body: {
          currentPassword: value.currentPassword,
          newPassword: value.newPassword,
          confirmNewPassword: value.confirmNewPassword
        }
      }
    )
      .pipe(
        take(1),
        finalize(() => {
          this.updateBtnLoading = false;
        })
      )
      .subscribe(response => {
        this.snackBar.onResponse(response);
        this.dialogRef.close();
      });
  }

  /**
   * Save work address
   */
  saveWorkAddress() {
    if (this.workAddressFormGroup.invalid) {
      reactiveFormValidator(this.workAddressFormGroup);
      this.saveBtnLoading = false;
      return;
    }
    this.saveBtnLoading = true;
    const value = this.workAddressFormGroup.value;
    this.workPartner.country = value.workCountry ? {id: value.workCountry} : null;
    this.workPartner.state = value.workState ? {id: value.workState} : null;
    this.workPartner.county = value.workCounty ? {id: value.workCounty} : null;
    this.workPartner.city = value.workCity;
    this.workPartner.zipCode = value.workZipCode;
    this.workPartner.street1 = value.workStreet1;
    this.workPartner.street2 = value.workStreet2;
    this.workPartner.phone = value.workPhone;
    this.workPartner.phoneExtension = value.workPrefix;
    this.workPartner.fax = value.workFax;
    this.workPartner.faxExtension = value.workFaxPrefix;

    this.restService.request<Payment>(
      RequestMethod.POST,
      ApiEndpoints.RES.PARTNER,
      'update-profile',
      {
        body: this.workPartner,
        params: {ignoreNullsExcept: ['state', 'county'], changeProfilePicture: false}
      }
    )
      .pipe(
        take(1),
        finalize(() => {
          this.saveBtnLoading = false;
        })
      )
      .subscribe(response => {
        this.snackBar.onResponse(response);
        this.dialogRef.close();
      });
  }

  /**
   * Cancel
   */
  cancel(): void {
    if (this.myProfileFormGroup.touched || this.changePasswordFormGroup.touched || this.workAddressFormGroup.touched) {
      const dialogRef = this.matDialog.open(ConfirmModalComponent, {
        data: {
          fullName: 'Warning',
          name: '',
          type: 'Confirm',
          removeQuestionMark: true,
          content: 'You have unsaved changes. If you close the pop-up window, these changes will be lost.'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.delete) {
          this.dialogRef.close();
        }
        return;
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Set card image.
   */
  private getCardBrand(card: any) {
    const PATH = 'assets/images/cards/';

    switch (card.brand) {
      case 'visa': {
        return PATH + 'visa.svg';
      }
      case 'mastercard': {
        return PATH + 'mastercard.svg';
      }
      case 'discover': {
        return PATH + 'discover.svg';
      }
      case 'unionpay': {
        return PATH + 'unionpay.svg';
      }
      case 'jcb': {
        return PATH + 'jcb.svg';
      }
      case 'diners': {
        return PATH + 'diners.svg';
      }
      case 'American Express': {
        return PATH + 'bank_1.png';
      }
      case 'amex': {
        return PATH + 'amex.svg';
      }
    }
  }

  /*
  ** - Show SnackBar
  ** - Notify Parent for changes
   */
  private onShowSnackBar(response): void {
    const message = response.message;
    if (response && response.success) {
      this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
      this.getAllCards();
    } else {
      this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
      this.getAllCards();
    }
  }

  /**
   * Fetch cards.
   */
  private getAllCards(): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.READ}/cards`;
    this.restService
      .restRequest<any>(
        RequestMethod.GET,
        URL
      )
      .subscribe(response => {
        if (response.success) {
          this.cards = response.data.cards;
          this.defaultCard = response.data.defaultCard;
        }
      });
  }

  getSpecialties() {
    this.restService.request<PageableResponse<any>>(RequestMethod.GET, ApiEndpoints.RES.SPECIALTY,
      Actions.BASE_ACTIONS.READALL).subscribe(
      response => {
        if (response.success) {
          this.specialties = response.data.items;
          return;
        }
        this.responseSnackBar.onResponse(response);
      }
    );
  }

  private getAssignedFacilites() {
    this.restService.request<any>(RequestMethod.GET, ApiEndpoints.RES.FACILITY,
      `${Actions.BASE_ACTIONS.READ}/programs/assigned/${this.user.id}`).subscribe(
      response => {
        if (response.success) {
          response.data.forEach(item => {
            this.assignedPrograms.push(item.id);
          });
          return;
        }
        this.responseSnackBar.onResponse(response);
      }
    );
  }

  getCheckedAssigment(event: any) {
    if (!event.source.selected) {
      if (this.assignedPrograms.includes(event.source.value) && event.isUserInput) {
        const foundProgram = this.programs.find(x => x.id === event.source.value);
        const programDescription = foundProgram?.description;
        this.responseSnackBar.onResponseMessage(
          `This user has a facility assigned with ${programDescription}. Please remove existing assignments first.`,
          GeneralConstant.SNACKBAR_ERROR_CLASS);
        this.myProfileFormGroup.get('programs').setValue(this.myProfileFormGroup.get('programs').value.map(it => it));
      }
    }
  }

  private getAllSpokenLanguages() {
    this.restService.request<any>(RequestMethod.GET, ApiEndpoints.RES.SPOKEN_LANGUAGE, Actions.BASE_ACTIONS.READ).subscribe(
      response => {
        if (response.success) {
          this.spokenLanguages = response.data;
        }
      }
    );
  }

  getPrograms() {
    this.restService.request<PageableResponse<FacilityProgram>>(RequestMethod.GET, ApiEndpoints.ACCR.SUBTYPE,
      Actions.BASE_ACTIONS.READ + `?readAll=true`).subscribe(
      response => {
        if (response.success) {
          this.programs = response.data.items;
        } else {
          this.responseSnackBar.onResponse(response);
        }
      }
    );
  }

  getStates(control: AbstractControl, countyControl: AbstractControl, event) {
    if (event.value === this.usaId) {
      control.enable();
      return;
    } else {
      control.disable();
      control.setValue(null);
      countyControl.disable();
      countyControl.setValue(null);
    }
  }

  private getCountries() {
    this.locationService.getCountries().subscribe(response => {
      this.countryList = response;
    });
    this.locationService.getStates(this.usaId).subscribe(result => {
      this.stateList = result;
    });
  }

  getCounties(stateControl: AbstractControl, countyControl: AbstractControl, county, value) {
    if (countyControl.disabled && value) {
      countyControl.enable();
    }
    if (value) {
      this.getCountiesByStateId(value, county);
      countyControl.updateValueAndValidity();
    }
  }

  private getCountiesByStateId(stateId, county) {
    this.locationService.getCounties(stateId).subscribe(response => {
      this.workCountyList = response;
    });
  }

  /**
   * Get all certifying board types.
   */
  getAllCertifyingBoardTypes() {
    this.staffService.getCertifyingTypes().subscribe(response => {
      if (response.success) {
        this.certifyingBoardData = response.data;
      } else {
        this.responseSnackBar.onResponse(response);
      }
    });
  }

  /**
   * Get all certifying board types.
   */
  getMemberBoardTypes(id: number) {
    this.staffService.getMemberBoardTypes(id).subscribe(response => {
      if (response.success) {
        this.memberBoardData = response.data;
      }
    });
  }

  onCertifyingBoardChange(event: any) {
    if (event.value) {
      this.getMemberBoardTypes(event.value);
    }
    if (!this.myProfileFormGroup.get('memberBoard')?.value) {
      this.myProfileFormGroup.get('memberBoard').enable();
    }
    if (!this.myProfileFormGroup.get('certifyingBoard')?.value) {
      this.myProfileFormGroup.get('memberBoard').disable();
    }
    this.myProfileFormGroup.get('memberBoard').setValue(null);
  }
}
